export const GET_DASHBOARD = 'dashboard/GET_DASHBOARD';
export const GET_PERIOD_DATE_FILTER_DASHBOARD =
  'dashboard/GET_PERIOD_DATE_FILTER_DASHBOARD';
export const GET_DATE_FILTER_DASHBOARD = 'dashboard/GET_DATE_FILTER_DASHBOARD';

export const SET_DASHBOARD = 'dashboard/SET_DASHBOARD';
export const SET_PERIOD_DATE_FILTER_DASHBOARD =
  'dashboard/SET_PERIOD_DATE_FILTER_DASHBOARD';
export const SET_DATE_FILTER_DASHBOARD = 'dashboard/SET_DATE_FILTER_DASHBOARD';

export const FETCH_DASHBOARD = 'dashboard/FETCH_DASHBOARD';
export const SAVE_PERIOD_DATE_FILTER_DASHBOARD =
  'dashboard/SAVE_PERIOD_DATE_FILTER_DASHBOARD';
export const SAVE_DATE_FILTER_DASHBOARD =
  'dashboard/SAVE_DATE_FILTER_DASHBOARD';
